import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
// import { simLogTooLarge } from '../../../../../shared/utils/SimulcastLogger';
import { GREEN, Label, Message, RED, Row, TimeStamp, getColor } from '../Styles';
import { icons } from './../utils';

const screenSettings = {
  auctioneer: {
    icon: icons.yellowCircle,
    screen: 'Auctioneer',
  },
  clerk: {
    icon: icons.orangeCircle,
    screen: 'Clerk',
  },
  login: {
    icon: icons.purpleCircle,
    screen: 'Launch Pad',
  },
  'tote-large': {
    icon: icons.blueCircle,
    screen: 'Tote',
  },
  'tote-small': {
    icon: icons.blueCircle,
    screen: 'Tote',
  },
};

export const ExpandedView = observer(({ largerMonitor }) => {
  const {
    AuctionStore: { connected, networkConnected },
    DebuggerStore: { getLog, simLogTooLarge },
  } = useStores();

  
  // const logTooBig = simLogTooLarge();
  const logTooBig = simLogTooLarge;
  const isConnected = connected && networkConnected;
  const connectedColor = isConnected ? GREEN : RED;

  const log = getLog({ target: 'ui' });

  return (
    <>
      {log.map(({ message, messageType, method, slug, timestamp }, index) => {
        const { bgColor, color } = getColor(messageType);
        const slugName = slug?.toLowerCase();
        const shouldFlash = logTooBig ? false : index === 0;

        return (
          <Row
            flashColor={connectedColor}
            key={`${timestamp}; log-index=${index}`}
            latestMessage={shouldFlash}
          >
            <TimeStamp bgColor={bgColor} color={color}>
              {timestamp}
            </TimeStamp>
            <Message>{message}</Message>
            {largerMonitor && method && (
              <Label>
                <div>Event</div>
                <div>
                  {method?.indexOf('receiveMessage') > -1
                    ? icons.whiteCircle
                    : null}
                  {method?.indexOf('sendMessage') > -1
                    ? icons.blackCircle
                    : null}
                  {method}
                </div>
              </Label>
            )}
            {slug && (
              <Label>
                <div>Screen</div>
                <div style={{ textTransform: 'capitalize' }}>
                  {screenSettings[slugName].icon}
                  {screenSettings[slugName].screen}
                </div>
              </Label>
            )}
          </Row>
        );
      })}
    </>
  );
});

export default ExpandedView;
